import React from 'react';
import { useApp } from '../contexts/AppProvider';
import { ReactComponent as EvaaLogo } from '../assets/evaa-logo-blanc.svg';
import LanguageSelector from '../components/dependencies/LanguageSelector';
import { Info } from 'lucide-react';

export default function Header() {
	const { tenantInfos, t } = useApp();

	return (
		<header
			className="sticky top-0 z-10 p-2 sm:p-4 border-b shadow-sm"
			style={{ backgroundColor: 'color-mix(in srgb, var(--color-primary) 50%, white)' }}
		>
			<div className="max-w-9xl mx-auto flex items-center justify-between gap-2 sm:gap-4">
				{/* Left: App Title */}
				<h1
					className="text-sm sm:text-lg md:text-xl font-bold tracking-tight whitespace-nowrap"
					style={{ color: 'var(--color-primary)' }}
				>
					{t('appTitle')}
				</h1>

				{/* Center: Survey Title + Info Icon */}
				{tenantInfos?.surveyTitle && (
					<div className="flex items-center gap-1 sm:gap-2 relative group flex-1 min-w-0 justify-center">
						<h2 
							className="text-sm sm:text-xl md:text-2xl font-semibold text-center truncate"
							style={{ color: 'var(--color-primary)' }}
						>
							{tenantInfos.surveyTitle}
						</h2>
						{tenantInfos?.surveyId && (
							<div className="relative flex-shrink-0">
								<Info className="h-3 w-3 text-white cursor-pointer" />
								<span className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap z-20">
									{t('surveyId')}: {tenantInfos.surveyId}
								</span>
							</div>
						)}
					</div>
				)}

				{/* Right: Language Selector + Logo(s) */}
				<div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
					<div className="hidden sm:block">
						<LanguageSelector />
					</div>

					<div className="flex items-center gap-2 sm:gap-3">
						{tenantInfos?.logoUrl ? (
							<img 
								src={tenantInfos.logoUrl} 
								alt="Tenant Logo"
								className="h-6 sm:h-8 w-auto object-contain"
							/>
						) : (
							<div className="h-6 sm:h-8 w-auto flex items-center justify-center text-white font-bold">
								<EvaaLogo className="h-6 sm:h-8 w-auto" />
							</div>
						)}
						
						{/* Secondary Logo - only shows if it exists */}
						{tenantInfos?.secondaryLogoUrl && (
							<img 
								src={tenantInfos.secondaryLogoUrl} 
								alt="Secondary Logo"
								className="h-6 sm:h-8 w-auto object-contain"
							/>
						)}
					</div>
					
					{/* Mobile Language Selector */}
					<div className="sm:hidden">
						<LanguageSelector />
					</div>
				</div>
			</div>
		</header>
	);
}